import { useTranslation } from "react-i18next";
import classNames from "classnames";

import styles from "./ToggleButtons.module.scss";

interface ToggleButtonsProps {
  value: boolean;
  trueLabel?: string;
  falseLabel?: string;
  trueExtraText?: string | null;
  isDisabled?: boolean;
  onChange: (value: boolean) => void;
}

export const ToggleButtons = ({
  value,
  trueLabel,
  falseLabel,
  trueExtraText,
  isDisabled = false,
  onChange,
}: ToggleButtonsProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <button
        className={classNames(styles.paymentStatusBtn, { [styles.green]: value })}
        disabled={isDisabled}
        onClick={() => onChange(true)}
      >
        {trueLabel ?? t("enums.answers.yes")} {value && trueExtraText ? trueExtraText : null}
      </button>
      <button
        className={classNames(styles.paymentStatusBtn, { [styles.red]: !value })}
        disabled={isDisabled}
        onClick={() => onChange(false)}
      >
        {falseLabel ?? t("enums.answers.no")}
      </button>
    </div>
  );
};
